var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top-header',{attrs:{"type":6,"placeholder":'VR体验',"hasBorder":true,"bgColor":'#fff',"fontSize":"0.32rem"}}),_c('iframe',{attrs:{"src":_vm.iframeSrc,"scrolling":"auto","frameborder":"0","id":"iframe"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }